<template lang="pug">
    div.deliver-form
        template
            el-form(
                :model="formData"
                :rules="rules"
                ref="form"
            )
                el-form-item.padding-left(
                    label="成本金额(元)："
                    prop="orderAmount"
                    v-if="detailData.orderType === 'MAINTAIN' && checkData && checkData.content"
                )
                    span(style="color: #333; margin-right: 8px;") 总计  {{ checkData.content.overhaulAmount | amountFormat }}
                    span(style="color: rgba(0,0,0,0.45);")
                        span(style="margin-right: 12px;") (工时费：{{ checkData.content.overhaulPersonnelAmount | amountFormat }}
                        span 材料费：{{ checkData.content.overhaulMaterialAmount | amountFormat }})
                el-form-item.padding-left(
                    label="拆分金额细项："
                    prop=""
                )
                    div.switch-box
                        div.switch-item()
                            el-switch(
                                v-model="isAmountDetail"
                            )
                div.detail-amount-box(v-if="isAmountDetail")
                    el-form-item.special.detail-amount-form(
                        label="应收合计(元)："
                        prop="originalAmount"
                    )
                        el-popover(
                            placement="top-start"
                            trigger="hover"
                        )
                            div(style="line-height: 20px;")
                                span 应收合计金额凯励程APP服务详情客户可见
                            svg-icon(
                                slot="reference"
                                icon-class="help-collision"
                                className="tooltip-sign"
                                style="position: absolute; top: 9px; left: 100px"
                            )
                        el-input(
                            style="width: 306px;"
                            maxlength="11"
                            v-model="formData.paymentAmountDetail.originalAmount"
                            placeholder="请输入"
                        )
                    el-form-item.required-star(
                        label="优惠合计(元)："
                        prop="discountAmount"
                    )
                        el-popover(
                            placement="top-start"
                            trigger="hover"
                        )
                            div(style="line-height: 20px;")
                                span 门店此次结算若含有优惠费用则可填写，凯励程APP服务详情客户可见
                            svg-icon(
                                slot="reference"
                                icon-class="help-collision"
                                className="tooltip-sign"
                                style="position: absolute; top: 9px; left: 100px"
                            )
                        el-input(
                            style="width: 306px;"
                            maxlength="11"
                            v-model="formData.paymentAmountDetail.discountAmount"
                            placeholder="请输入"
                        )
                    el-form-item.padding-left.mar-b-0(
                        label="结算金额(元)："
                        prop="detailPaymentAmount"
                    )
                        div.detail-payment-amount {{ paymentAmount | amountFormat }}
                        div.detail-payment-tips 结算金额=应收合计-优惠合计
                el-form-item.required-star(
                    v-if="!isAmountDetail"
                    label="结算金额(元)："
                    prop="paymentAmount"
                )
                    el-input(
                        style="width: 408px;"
                        maxlength="11"
                        v-model="formData.paymentAmount"
                        placeholder="请输入"
                    )
                el-form-item.padding-left(
                    label="下次保养里程(km):"
                    prop="nextMaintenanceMileage"
                )
                    el-input(
                        style="width: 408px;"
                        v-model.trim="formData.nextMaintenanceMileage"
                        maxlength="8"
                        placeholder="请输入"
                    )
                el-form-item.padding-left(
                    label="下次保养时间："
                    prop="nextMaintenanceTime"
                )
                    el-date-picker(
                        style="width: 408px;"
                        v-model.trim="formData.nextMaintenanceTime"
                        type="date"
                        placeholder="请选择"
                        class="repair-time"
                        clearable
                        :editable="false"
                        :picker-options="repairTimeOptions"
                    )
                el-form-item.padding-left(
                    label="建议保养项目："
                    prop="nextMaintenanceProject"
                )
                    el-select(
                        style="width: 408px;"
                        v-model="formData.nextMaintenanceProject"
                        placeholder="请选择"
                        clearable
                        multiple
                    )
                        el-option(
                            v-for="item in projectOptions"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                        )
                el-form-item.padding-left.upload-pictures(
                    label="图片凭证:"
                    prop="deliverPicture"
                )
                    UploadFormItem(@change="onPicChange" :asyncfileList="deliverPictureFull", :limit="9")
            span.dialog-footer(slot="footer" style="margin-top: 20px")
                el-popover(placement="bottom" width="190" v-model="visible" popper-class="padding-16 text-left")
                    div(style="text-align: right; margin: 0")
                        p 确认提交当前处理结果？
                        el-button.pop-button(@click="visible = false") 取消
                        el-button.pop-button.primary(@click="handleSubmit") 确定
                    el-button.button(slot="reference" round type="primary" :loading="loading") 提交
</template>

<script>
import { workOrderApis } from '@/api';
import UploadFormItem from '@/components/Common/UploadFormItem.vue';
import workOrderMixin from '../../../mixins/workOrder';

export default {
    name: 'ResolveOrder',
    components: {
        UploadFormItem,
    },
    props: {
        detailData: {
            type: Object,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [workOrderMixin],
    computed: {
        isAutoX3MaintenanceCheck() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE_CHECK')) || this.detailData.autox3MaintenanceCheck;
        },
        checkData() {
            return this.isAutoX3MaintenanceCheck ? this.detailData.autox3MaintenanceCheck : this.detailData.maintenanceCheck;
        },
        paymentAmount() {
            return Number(this.formData.paymentAmountDetail.originalAmount) - Number(this.formData.paymentAmountDetail.discountAmount);
        },
    },
    data() {
        const validateAmount = (rule, value, callback) => {
            const amountReg = /^([1-9]\d*|0)((\.\d{1,2})?)$/;
            if (!value && !this.isAmountDetail) {
                callback(new Error('请输入结算金额'));
            } else if (value && !this.isAmountDetail && !amountReg.test(value)) {
                callback(new Error('请输入正确的结算金额'));
            } else if (value > 100000000 && !this.isAmountDetail) {
                callback(new Error('结算金额最大不超过100000000'));
            } else {
                callback();
            }
        };
        const validateMileage = (rule, value, callback) => {
            const mileReg = /^([1-9][0-9]*)$/;
            if (value && !mileReg.test(value)) {
                callback(new Error('请输入正确的里程，里程数为正整数'));
            } else if (value && !(value > this.detailData.currentMileage)) {
                callback(new Error('下次保养里程数不能小于当前里程数'));
            } else {
                callback();
            }
        };
        const validateOriginalAmount = (rule, value, callback) => {
            const amountReg = /^([0-9]\d*|0)((\.\d{1,2})?)$/;
            const amount = this.formData.paymentAmountDetail.originalAmount;
            if (!amount && this.isAmountDetail) {
                callback(new Error('请输入应收金额'));
            }
            if (this.isAmountDetail && !amountReg.test(amount)) {
                callback(new Error('请输入正确的应收金额'));
            }
            if (amount > 100000000 && this.isAmountDetail) {
                callback(new Error('应收金额最大不超过100000000'));
            }
            callback();
        };
        const validateDiscountAmount = (rule, value, callback) => {
            const amountReg = /^([0-9]\d*|0)((\.\d{1,2})?)$/;
            const amount = this.formData.paymentAmountDetail.discountAmount;
            if (!amount && this.isAmountDetail) {
                callback(new Error('请输入优惠金额'));
            }
            if (this.isAmountDetail && !amountReg.test(amount)) {
                callback(new Error('请输入正确的优惠金额'));
            }
            if (amount > 100000000 && this.isAmountDetail) {
                callback(new Error('优惠金额最大不超过100000000'));
            }
            callback();
        };
        const validateDetailPaymentAmount = (rule, value, callback) => {
            const amount = this.paymentAmount;
            if (amount < 0 && this.isAmountDetail) {
                callback(new Error('结算金额不能为负'));
            }
            callback();
        };
        return {
            isAmountDetail: false,
            formData: {
                stepName: 'DELIVER',
                paymentAmount: '',
                nextMaintenanceTime: '',
                nextMaintenanceMileage: '',
                nextMaintenanceProject: [],
                deliverPicture: [],
                paymentAmountDetail: {
                    amountItems: [],
                    originalAmount: '',
                    discountAmount: '',
                    paymentAmount: '',
                },
            },
            rules: {
                paymentAmount: [
                    {
                        validator: validateAmount,
                        trigger: 'blur',
                    },
                ],
                originalAmount: [
                    {
                        validator: validateOriginalAmount, trigger: ['submit', 'blur', 'input'],
                    },
                ],
                discountAmount: [
                    {
                        validator: validateDiscountAmount, trigger: ['submit', 'blur', 'input'],
                    },
                ],
                detailPaymentAmount: [
                    {
                        validator: validateDetailPaymentAmount, trigger: ['submit'],
                    },
                ],
                nextMaintenanceMileage: [
                    {
                        validator: validateMileage,
                        trigger: 'blur',
                    },
                ],
                nextMaintenanceTime: [
                    {
                        required: false,
                        message: '请选择下次维保时间',
                        trigger: 'change',
                    },
                ],
                nextMaintenanceProject: [
                    {
                        required: false,
                        message: '请选择建议维保项目',
                        trigger: 'change',
                    },
                ],
            },
            repairTimeOptions: {
                disabledDate(time) {
                    const now = new Date();
                    return time.getTime() < Date.now() || time.getTime() > now.setFullYear(now.getFullYear() + 1);
                },
            },
            projectOptions: [],
            deliverPictureFull: [],
            deliverPic: [],
            visible: false,
        };
    },
    mounted() {
        this.getProjectItems();
    },
    methods: {
        initFormData() {
        },
        async getProjectItems() {
            const { data } = await workOrderApis.getMaintainProjects();
            this.projectOptions = data || [];
        },
        onPicChange(files) {
            this.deliverPic = files;
        },
        async validateFormData(type) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let deliverUrls = [];
                    if (this.deliverPic.length) {
                        deliverUrls = await this.uploadToOss(this.deliverPic).catch(() => {
                            this.$message('凭证图片上传失败');
                            throw new Error('凭证图片上传失败');
                        });
                        this.formData.deliverPicture = deliverUrls;
                    }
                    if (!this.isAmountDetail) {
                        this.formData.paymentAmountDetail = null;
                    } else {
                        this.formData.paymentAmount = 0;
                        this.formData.paymentAmountDetail.paymentAmount = this.paymentAmount.toFixed(2);
                        this.formData.paymentAmountDetail.originalAmount = Number(this.formData.paymentAmountDetail.originalAmount).toFixed(2);
                        this.formData.paymentAmountDetail.discountAmount = Number(this.formData.paymentAmountDetail.discountAmount).toFixed(2);
                    }
                    this.$emit('submit', { data: this.formData, type });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
    .deliver-form {
        padding: 20px 0 20px 20px;
        flex: 1;
        .switch-box {
            display: flex;
            .switch-item {
                margin-right: 36px;
            }
        }
        .jump-tag {
            width: 60px;
            height: 30px;
            line-height: 28px;
            text-align: center;
            background: #F5F5F5;
            border: 1px solid #EEEEEE;
            border-radius: 4px;
            font-size: 14px;
            color: #999999;
            margin-bottom: 10px;
            font-weight: normal;
        }
        .info-operator {
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            color: #999999;
            font-weight: 400;
        }
    }
    .pop-button {
        width: 44px;
        height: 24px;
        border-radius: 4px;
        padding: 0!important;
        font-size: 12px;
        color: rgba(0,0,0,0.65);
        border: 1px solid rgba(0,0,0,0.15);
        &.primary {
            color: #FFFFFF;
            background: #2970FF;
            border: none;
            margin-left: 8px;
        }
    }
    .detail-amount-box {
        background: rgba(0,0,0,0.02);
        border-radius: 4px;
        padding: 18px 20px;
        margin-bottom: 20px;
        margin-right: 18px;
        .detail-amount-form {
            margin-bottom: 20px;
        }
        .detail-original-amount {
            font-size: 16px;
            color: rgba(0,0,0,0.85);
            line-height: 24px;
            font-weight: 500;
        }
        .detail-payment-amount {
            font-size: 16px;
            color: #FF6640;
            line-height: 24px;
            font-weight: 500;
        }
        .original-amount {
            margin-bottom: 12px;
        }
        .detail-payment-tips {
            font-size: 12px;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
            font-weight: 400;
        }
        .mar-b-0 {
            margin-bottom: 0!important;
        }
    }
</style>

<style lang="scss">
.deliver-form {
    overflow-y: hidden;
    .special {
        .el-form-item__label:before {
            content: '*';
            @include font_color(color_base_red6);
            margin-right: 4px;
        }
    }
    .item-input {
        position: relative;
        display: flex;
        &.m-b-20 {
            margin-bottom: 20px;
        }
    }
    .item-operate {
        @include font_size(text_big);
        position: absolute;
        right: 0;
        top: 0;
        .item-plus {
            margin-left: 5px;
            cursor:pointer;
        }
        .item-remove {
            cursor:pointer;
        }
    }
    .original-amount {
        .el-form-item__label {
            font-size: 12px;
            color: rgba(0,0,0,0.45);
            padding-left: 22px;
        }
    }
    .el-form {
        max-height: 500px;
        overflow-y: auto;
    }
    .el-form .el-form-item__content {
        padding-left: 136px;
    }
    .el-form-item__label {
        width: 136px!important;
        padding: 0;
    }
    .el-icon-date:before {
        position: relative;
        top: -4px;
    }
    .padding-left {
        .el-form-item__label {
            padding-left: 10px;
        }
    }
    .upload-pictures {
        .upload {
            height: auto;
            padding-left: 0!important;
            min-height: 80px;
        }
    }
    .el-form-item__error {
        margin-left: 136px;
    }
    .required-star {
        .el-form-item__label::before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
        }
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
        display: none;
    }
    ul.el-upload-list--picture-card {
        line-height: 0;
    }
    .upload-form-item .upload .el-upload--picture-card {
        margin-bottom: 8px;
    }
    .margin-bottom-12 {
        margin-bottom: 12px!important;
        .el-form-item__error {
            top: calc(100% - 8px);
        }
    }
    .small-margin {
        .el-form-item {
            margin-bottom: 12px!important;
            .el-form-item__label, .el-form-item__content {
                line-height: 22px;
            }
        }
    }
}
</style>
